/** `public/i/icon-threats-w.png` → `${BASE_URL}i/...` */
const threatUrl = `${import.meta.env.BASE_URL}i/icon-threats-w.png`;

if (typeof document !== 'undefined') {
  document.documentElement.style.setProperty('--rb-icon-threats', `url(${threatUrl})`);
}
